{
  "createFarmAddress_line_1": {
    "label": "Indirizzo Linea 1",
    "placeholder": "(Inserisci l'indirizzo della fattoria)"
  },
  "createFarmAddress_line_2": {
    "label": "Indirizzo riga 2",
    "placeholder": null
  },
  "createFarmCity": {
    "label": "Città",
    "placeholder": "(Inserisci città)"
  },
  "createFarmCountry": {
    "label": "Paese",
    "placeholder": "(Scegli Paese)"
  },
  "createFarmDescription": "Altrimenti, se sei il primo utente della tua farm, puoi creare un account farm. Dopo, puoi invitare altri utenti a unirsi alla tua farm.",
  "createFarmHelpTitle": "Informazioni sui conti agricoli",
  "createFarmLinkTo": "Nuovo account agricolo",
  "createFarmName": {
    "label": "Nome",
    "placeholder": "(Inserisci il nome della fattoria)"
  },
  "createFarmPostalCode": {
    "label": "Codice Postale",
    "placeholder": "(Inserisci il codice postale)"
  },
  "createFarmRegion": {
    "label": "Regione",
    "placeholder": "(Scegli la regione)"
  },
  "createFarmTitle": "Nuovo account agricolo",
  "createNewFarmAccount": "Crea un nuovo account fattoria",
  "enterFarmJoinCode": "Inserisci il codice di iscrizione alla fattoria",
  "enterYourFarmAddress": "Inserisci l'indirizzo della tua azienda agricola",
  "farmAccountHelpBodyText": "Il tuo account farm è una rappresentazione di una fattoria reale, che funge da hub per tutto quanto segue:\n\nDispositivi: i tuoi dispositivi monitorano i pezzi di attrezzatura per l'irrigazione utilizzando una varietà di sensori.\n\nCampi: i campi forniscono contesto agli aggiornamenti sullo stato dei dispositivi e aggregano i dati di irrigazione in base all'attività all'interno dei loro confini.\n\nUtenti: consentono ai responsabili e ai dipendenti della fattoria di interagire con il sistema FarmHQ.\n\nI tuoi account farm sono distinti dal tuo account utente in alcuni modi importanti. Non ci sono informazioni di accesso da ricordare, invece, quando accedi a farmhq.com con le tue credenziali personali, i dispositivi e i campi della tua fattoria verranno caricati automaticamente.\n\nD: Posso unirmi a più di un account farm?\n\nR: Sì. Una volta che sei membro di una fattoria, puoi navigare e unirti o creare un'altra fattoria.",
  "farmAccountHelpTitle": "Informazioni sui conti agricoli",
  "farmJoinCodeLabel": "Codice di adesione alla fattoria",
  "ifAnotherUserHasAlreadyCreatedYourFarmAccount": "Se qualcuno nella tua fattoria ha già creato un account fattoria, può darti un Farm Join Code. Puoi usare quel codice per collegare il tuo account utente all'account fattoria.",
  "instructions": "Successivamente, è necessario connettersi a un account farm.",
  "joinFarmAlreadyJoined": "Sei già membro di questo account agricolo.",
  "joinFarmDescription": "Se qualcuno nella tua fattoria ha già creato un account fattoria, può darti un Farm Join Code.\n\nCollega il tuo account utente all'account fattoria inserendo il codice qui sotto:",
  "joinFarmLinkTo": "Unisciti a un altro account Farm",
  "joinFarmTitle": "Unisciti a Farm con il codice",
  "joinFarmWithCode": "Unisciti a Farm con il codice",
  "joinFarmWithCodeHelpBodyText": "I Farm Join Codes consentono agli utenti di collegare il proprio account utente a un account farm. Unendosi a un account farm, gli utenti sono in grado di visualizzare e gestire tutti i dispositivi associati a tale farm.\n\nI Farm Join Codes sono codici univoci di 6 caratteri generati dal proprietario della farm. Se sei un utente a cui è stato assegnato un Farm Join Code, puoi inserirlo qui per unirti all'account farm.\n\nL'utente che ha creato il codice deve anche decidere quali autorizzazioni avrai sull'account farm. Ciò determinerà quali azioni puoi intraprendere sull'account farm.",
  "joinFarmWithCodeHelpTitle": "Informazioni sui codici di adesione alla fattoria",
  "newFarmAccount": "Nuovo account agricolo",
  "noFarmsTitle": "Nessuna fattoria",
  "successAddDevices": {
    "description": "Registra i tuoi dispositivi FarmHQ",
    "text": "Aggiungi dispositivi"
  },
  "successDrawFields": {
    "description": "Disegna i campi della tua fattoria",
    "text": "Disegna campi"
  },
  "successInstructions": "Ecco alcuni modi in cui puoi iniziare a usare FarmHQ",
  "successTitle": "Successo",
  "successViewSupport": {
    "description": "Esplora la nostra documentazione di supporto",
    "text": "Supporto"
  },
  "userAccountCreatedMessage": "Account utente creato",
  "welcomeToFarmHQ": "Benvenuti a FarmHQ",
  "whatWeUseFarmLocationForText": "Utilizziamo queste informazioni per assicurarci che le nostre funzionalità basate sulla mappa funzionino correttamente. Non condividiamo queste informazioni con terze parti.",
  "whatWeUseFarmLocationForTitle": "Raccolta indirizzi fattoria"
}
